var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7784 5.93183C14.0469 6.20031 14.0469 6.63562 13.7784 6.9041L9.68129 11.0013L13.7784 15.0985C14.0469 15.367 14.0469 15.8023 13.7784 16.0707C13.5099 16.3392 13.0747 16.3392 12.8062 16.0707L8.22285 11.4874C8.09392 11.3585 8.02148 11.1836 8.02148 11.0013C8.02148 10.819 8.09392 10.6441 8.22285 10.5152L12.8062 5.93183C13.0747 5.66335 13.5099 5.66335 13.7784 5.93183Z",
    fill: "#14489F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowLogin);
export default __webpack_public_path__ + "static/media/back_arrow_login.d78224aa32422562f39de9890a36b125.svg";
export { ForwardRef as ReactComponent };